module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_NORTH_STYLE.f20f6973.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_NORTH_STYLE.png
// module id = 1310
// module chunks = 16